import { render, staticRenderFns } from "./Cashier.vue?vue&type=template&id=22d95150&scoped=true"
import script from "./Cashier.vue?vue&type=script&lang=ts"
export * from "./Cashier.vue?vue&type=script&lang=ts"
import style0 from "./Cashier.vue?vue&type=style&index=0&id=22d95150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d95150",
  null
  
)

export default component.exports